import { DateTime } from 'luxon';
// Private calc helpers — the single home for VAT period end / legal deadline
// logic. Duplicate copies previously lived in JobNaming.ts and
// JobTemplateDefaults.ts. JobNaming.ts re-exports from here for back-compat;
// JobTemplateDefaults.ts calls resolveComputedClientDetailsField.
const QUARTER_END_MONTHS = {
    march_june_september_december: [2, 5, 8, 11], // Mar, Jun, Sep, Dec
    january_april_july_october: [0, 3, 6, 9], // Jan, Apr, Jul, Oct
    february_may_august_november: [1, 4, 7, 10], // Feb, May, Aug, Nov
};
/**
 * Calculate the next VAT period end date based on quarter pattern.
 * Returns the current quarter end if the reference date is on or before it,
 * otherwise the next quarter.
 */
export const calculateNextVatPeriodEnd = (quarterPattern, referenceDate = new Date()) => {
    const quarterMonths = QUARTER_END_MONTHS[quarterPattern];
    if (!quarterMonths) {
        return undefined;
    }
    const ref = DateTime.fromJSDate(referenceDate, { zone: 'utc' });
    const refMonth = ref.month - 1;
    let targetMonth = quarterMonths.find((m) => m >= refMonth);
    let targetYear = ref.year;
    if (targetMonth === undefined) {
        targetMonth = quarterMonths[0];
        targetYear = ref.year + 1;
    }
    return DateTime.fromObject({ year: targetYear, month: targetMonth + 1 }, { zone: 'utc' })
        .endOf('month')
        .toJSDate();
};
/** UK VAT legal filing deadline: 1 calendar month + 7 days after period end. */
export const calculateVatLegalDeadline = (periodEnd) => DateTime.fromJSDate(periodEnd, { zone: 'utc' }).plus({ months: 1, days: 7 }).toJSDate();
const computeVatPeriodEnd = ({ clientData, referenceDate }) => {
    if (!clientData || typeof clientData !== 'object') {
        return undefined;
    }
    const vatInfo = clientData.vatInformation;
    const pattern = vatInfo && typeof vatInfo === 'object' ? vatInfo.quarterPattern : undefined;
    if (typeof pattern !== 'string') {
        return undefined;
    }
    return calculateNextVatPeriodEnd(pattern, referenceDate);
};
const computeVatLegalDeadline = (ctx) => {
    const periodEnd = computeVatPeriodEnd(ctx);
    return periodEnd ? calculateVatLegalDeadline(periodEnd) : undefined;
};
export const COMPUTED_CLIENT_DETAILS_FIELD_DEFINITIONS = [
    {
        key: 'vatPeriodEnd',
        label: 'VAT Period End',
        valueType: 'date',
        section: 'vat',
        requires: ['vatInformation.quarterPattern'],
        compute: computeVatPeriodEnd,
    },
    {
        key: 'vatLegalDeadline',
        label: 'VAT Legal Deadline',
        valueType: 'date',
        section: 'vat',
        dateType: 'legal-deadline',
        requires: ['vatInformation.quarterPattern'],
        compute: computeVatLegalDeadline,
    },
];
const COMPUTE_BY_KEY = new Map(COMPUTED_CLIENT_DETAILS_FIELD_DEFINITIONS.map((entry) => [entry.key, entry.compute]));
/**
 * Resolves a computed client detail field by key. Returns undefined when the
 * key isn't a computed one (so callers can fall through to catalog lookup) or
 * when the computation can't proceed (e.g. required client data missing).
 */
export const resolveComputedClientDetailsField = (key, ctx) => COMPUTE_BY_KEY.get(key)?.(ctx);
export const isComputedClientDetailsFieldKey = (key) => COMPUTE_BY_KEY.has(key);
//# sourceMappingURL=ComputedClientDetailsFieldDefinition.js.map